(function () {
  'use strict';

  // Only these h3 sections become collapsible accordions
  var ACCORDION_SECTIONS = ['商品資訊'];

  function buildAccordions() {
    // 只處理商品頁描述；其他頁（配送說明、退換貨）的 .rte 結構不同，碰了會把內文弄不見
    if (!document.querySelector('main[data-template^="product"]')) return;

    var containers = Array.from(document.querySelectorAll('.rte')).filter(function (el) {
      return el.querySelector('h3');
    });

    containers.forEach(function (desc) {
      var contentRoot = desc.querySelector('div') || desc;
      var children = Array.from(contentRoot.children);
      // 沒有直屬 h3 就整個跳過，不能先搬動節點
      var hasDirectH3 = children.some(function (el) { return el.tagName === 'H3'; });
      if (!hasDirectH3) return;

      var accordionStack = document.createElement('div');
      accordionStack.className = 'metme-accordion-stack';
      var introFrag = document.createDocumentFragment();
      var currentBody = null;
      var foundH3 = false;

      children.forEach(function (el) {
        if (el.tagName === 'H3') {
          foundH3 = true;
          var headingText = el.textContent.trim();
          var isAccordion = ACCORDION_SECTIONS.indexOf(headingText) !== -1;

          if (isAccordion) {
            var details = document.createElement('details');
            var summary = document.createElement('summary');
            var span = document.createElement('span');
            span.textContent = headingText;
            summary.appendChild(span);
            currentBody = document.createElement('div');
            currentBody.className = 'metme-detail-body';
            details.appendChild(summary);
            details.appendChild(currentBody);
            accordionStack.appendChild(details);
          } else {
            var section = document.createElement('div');
            section.className = 'metme-section';
            var heading = document.createElement('div');
            heading.className = 'metme-section-heading';
            heading.textContent = headingText;
            currentBody = document.createElement('div');
            currentBody.className = 'metme-detail-body';
            section.appendChild(heading);
            section.appendChild(currentBody);
            accordionStack.appendChild(section);
          }
        } else if (foundH3 && currentBody) {
          currentBody.appendChild(el);
        } else {
          introFrag.appendChild(el);
        }
      });

      if (!foundH3) return;

      contentRoot.innerHTML = '';
      contentRoot.appendChild(introFrag);
      contentRoot.appendChild(accordionStack);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildAccordions);
  } else {
    buildAccordions();
  }
})();
